import React from 'react';

const VisaComp = () => {
  return (
    <div className="Visa mg-top-120">
      <p>
        En cas de difficultés administratives ou bureaucratiques, EXIFOD offre
        un soutien expert et personnalisé pour naviguer à travers les processus
        complexes de demande de visa. son assistance va au-delà de simples
        conseils : elle inclut souvent des services de conseil sur les documents
        requis, des contacts directs avec les autorités consulaires, et des
        orientations sur les démarches à suivre pour maximiser les chances de
        succès.
      </p>
    </div>
  );
};
export default VisaComp;
